import * as Sentry from '@sentry/nuxt'

export default defineNuxtPlugin(() => ({
    provide: {
        throwError: (error: any, msg: string) => {
            if (process.env.NODE_ENV === 'test') return msg

            const status = error?.response?.status || error?.status || 500
            const code = error?.code || ''
            const stack = error?.response?.data?.exception || error?.data

            const userId = useUserSession().user?.value?.id || 'unknown'

            const data = {
                name: error.name,
                message: error.message,
                statusCode: status,
                userId,
                dataResponse:
                    stack || error?.response?._data || 'No data provided'
            }

            const newError = new Error(`Error ${status} ${code}: ${msg}`, error)

            if (status === 404) {
                return
            }

            if (status >= 500) {
                Sentry.captureException(newError, {
                    tags: {
                        section: 'msg'
                    },
                    extra: data
                })
            } else if (status >= 400) {
                throw newError
            }
        }
    }
}))
